import './instrument';

import { StrictMode } from 'react';
import * as pkg from 'react-helmet-async';
import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import { ErrorBoundary } from '@sentry/react';

import './index.css';
import App from './App';
import { ScrollToTop } from '@/components';

const { HelmetProvider } = pkg.default ?? pkg;

// Browser translation extensions (Google Translate, etc.) mutate the DOM out
// from under React, so its commit phase calls removeChild/insertBefore on a
// node the extension already moved, throwing a NotFoundError that crashes
// the whole tree (Sentry CLIENT-3). No upstream fix exists; the
// mitigation is to make both ops no-throw on a foreign node.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  const originalInsertBefore = Node.prototype.insertBefore;

  Node.prototype.removeChild = function removeChild(child) {
    if (child.parentNode !== this) return child;

    return originalRemoveChild.apply(this, arguments);
  };

  Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) return newNode;

    return originalInsertBefore.apply(this, arguments);
  };
}

hydrateRoot(
  document.getElementById('root'),
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ErrorBoundary fallback={<p>Something went wrong.</p>}>
          <ScrollToTop />
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);
